import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import { Provider } from 'react-redux';
import store from '../redux/store';

import './App.css';

import {
  ROUTE_TEAMS,
  ROUTE_TEAM,
  ROUTE_TEAM_PROJECTS,
  ROUTE_TEAM_PROJECT,
  ROUTE_TEAM_PROJECT_SCENES,
  ROUTE_TEAM_PROJECT_SCENE
} from '../config/routes'

import Teams from './Teams/Teams';
import Team from './Team/Team';
import TeamProjects from './TeamProjects/TeamProjects';
import TeamProject from './TeamProject/TeamProject';
import TeamProjectScenes from './TeamProjectScenes/TeamProjectScenes';
import TeamProjectScene from './TeamProjectScene/TeamProjectScene';

const extractRouteParams = ( route ) => route.match.params;

function App() {
  return (
    <Provider store={store}>
      <Router>
        {/* DETERMINE THE CURRENT ROUTE */}
        <Switch>
          {/* LIST OF TEAMS USER BELONGS TO */}
          <Route exact path={ROUTE_TEAMS} render={( route ) => {
            const params = extractRouteParams( route );
            return <Teams {...params} />
          }} />
          {/* SHOW A TEAM PAGE */}
          <Route exact path={ROUTE_TEAM} render={( route ) => {
            const params = extractRouteParams( route );
            return <Team {...params} />
          }} />
          {/* SHOW A TEAM'S PROJECTS */}
          <Route exact path={ROUTE_TEAM_PROJECTS} render={( route ) => {
            const params = extractRouteParams( route );
            return <TeamProjects {...params} />
          }} />
          {/* SHOW A TEAM'S PROJECT */}
          <Route exact path={ROUTE_TEAM_PROJECT} render={( route ) => {
            const params = extractRouteParams( route );
            return <TeamProject {...params} />
          }} />
          {/* SHOW A TEAM'S PROJECT'S SCENES */}
          <Route exact path={ROUTE_TEAM_PROJECT_SCENES} render={( route ) => {
            const params = extractRouteParams( route );
            return <TeamProjectScenes {...params} />
          }} />
          {/* SHOW A TEAM'S PROJECT'S SCENE */}
          <Route path={ROUTE_TEAM_PROJECT_SCENE} render={( route ) => {
            const params = extractRouteParams( route );
            return <TeamProjectScene {...params} />
          }} />
          {/* PREVIEW */}
          {/* <Route path={ROUTE_PREVIEWS} render={( route ) => {
            const params = extractRouteParams( route );
            return <Preview {...params} />
          }} /> */}
          {/* DEFAULT */}
          <Route render={() => <Redirect to={ROUTE_TEAMS} />} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
